import React, { useState } from "react";
import { PopupButton } from "react-calendly";
import ctaIcon1 from "../../Images/img/Component 3-9.png";
export default function CalendlyButton({
  text = "Hier Kostenloses Erstgespräch",
  url = "https://calendly.com/bestandskunden-uneva/30min?primary_color=1b3662",
  className = "",
}) {
  const [hover, setHover] = useState(false);

  const phoneIcon = ctaIcon1;

  return (
    <div className="flex justify-center ">
      <div
        className={className}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <PopupButton
          url={url}
          rootElement={document.getElementById("root")}
          text={
            <span style={{ display: "flex", alignItems: "center" }}>
              <img src={ctaIcon1} alt="" className="mr-2 brightness-0 invert" />

              {text}
            </span>
          }
          styles={{
            padding: "12px 24px",
            backgroundColor: "#0b2b40",
            color: "#fff",
            borderRadius: "8px",
            border: "none",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "opacity 0.25s ease",
            opacity: hover ? 0.9 : 1,
          }}
        />
      </div>
    </div>
  );
}
